export default "/images/vendor/flag-icons/flags/1x1/mx.svg?023324073a66bdde59b1731153dbcb4d";